// Live keyword heuristics (mirrors backend classifier fallback); the server-side AI classifier is authoritative.
const KEYWORDS = {
  regulated_health_fintech: ["health", "clinic", "patient", "doctor", "telemedicine", "insurance", "loan", "lending", "fintech", "wallet", "credit", "pharmacy", "hipaa", "nbfc", "upi", "diagnostic", "neobank"],
  two_sided_marketplace: ["marketplace", "two-sided", "connects", "connecting", "match", "peer-to-peer", "booking platform", "buyers and sellers", "commission"],
  enterprise_b2b_saas: ["enterprise", "soc2", "soc 2", "compliance", "procurement", "vendor contract", "erp", "security team", "legal team", "audit", "dpdp", "gdpr"],
  food_cloud_kitchen: ["restaurant", "cloud kitchen", "tiffin", "meal", "lunch", "dinner", "food", "catering", "bakery"],
  physical_retail_cafe_coworking: ["cafe", "coffee", "co-working", "coworking", "store", "shop", "retail outlet", "lounge", "gym", "salon", "showroom", "high street", "high-street"],
  coaching_consulting_agency: ["coaching", "coach", "consulting", "consultancy", "agency", "freelance", "advisory", "training", "tutor", "mentor"],
  manufacturing_hardware: ["manufactur*", "hardware", "device", "factory", "3d print*", "electronics", "sensor", "iot", "machine", "biodegradable", "packaging"],
  saas_ai_aggregator: ["saas", "app", "ai", "aggregator", "price", "chrome extension", "api", "dashboard", "analytics", "software", "retail media", "q-commerce"],
};
const LOCAL = ["delivery", "hyperlocal", "pin code", "pin-code", "pincode", "neighbourhood", "neighborhood", "store", "shop", "cafe", "coffee", "restaurant", "kitchen", "food", "meal", "lunch", "retail", "gym", "salon", "clinic", "local", "outlet", "lounge", "co-working", "coworking", "high street", "high-street", "sector"];

const esc = (w) => w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
// Whole word (+ optional plural); a trailing * marks a deliberate stem, e.g. manufactur*.
const pattern = (w) => (w.endsWith("*") ? `\\b${esc(w.slice(0, -1))}` : `\\b${esc(w)}(?:s|es)?\\b`);
const hits = (text, words) => words.filter((w) => new RegExp(pattern(w)).test(text)).length;

export const guessArchetype = (ideaText) => {
  const text = (ideaText || "").toLowerCase();
  if (text.trim().length < 20) return null;
  let best = null;
  let bestScore = 0;
  Object.entries(KEYWORDS).forEach(([key, words]) => {
    const s = hits(text, words);
    if (s > bestScore) { best = key; bestScore = s; }
  });
  return best;
};

export const needsLocalCatchment = (ideaText) => hits((ideaText || "").toLowerCase(), LOCAL) > 0;
